import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchCMoAuthDetails } from '../../../utilities/API/caseServices';

export const oAuthCMDetails = createAsyncThunk(
    'oAuth/CM', fetchCMoAuthDetails
)


const initialState = {
    loader: false,
}

const oAuthCMSlice = createSlice({
    name: 'CMoAUth',
    initialState,

    reducers: {
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(oAuthCMDetails.pending, (state, action) => {
            })
            .addCase(oAuthCMDetails.fulfilled, (state, action) => {
            })
            .addCase(oAuthCMDetails.rejected, (state, action) => {
            })
    },
})

export default oAuthCMSlice.reducer
